import { combineReducers } from 'redux-immutable';

import { CatalogKeys } from '../../constants/Catalog';
import mapApiDataToSubstate from '../../lib/configuration/ApiDataMapper';
import createFilter from '../../tools/ReduxPersistFilter';

import albumsReducer from './Albums';
import artistsReducer from './Artists';
import browseSourcesReducer from './BrowseSource';
import catalogReducer from './Catalog';
import catalogStationsReducer from './CatalogStations';
import categoriesReducer from './Categories';
import composersReducer from './Composers';
import curatorSourcesReducer from './CuratorSources';
import eventsReducer from './Events';
import genresReducer from './Genres';
import listenersReducer from './Listeners';
import lyricsReducer from './Lyrics';
import playlistReducer from './Playlists';
import playlistTracksReducer from './PlaylistTracks';
import seedsReducer from './Seeds';
import stationsReducer from './Stations';
import tracksReducer from './Tracks';

export function getPreloadedApiData() {
  return window._store;
}

const SERVER_SIDE_INITIAL_STATE = mapApiDataToSubstate(getPreloadedApiData());

export const EntityFilter = createFilter({
  reducer: 'entities',
  keys: ['listeners', 'playlistTracks', 'stations', 'catalog'],
  inbound(state) {
    let newState = state;

    const catalogMap = state.get(CatalogKeys.CATALOG);
    if (catalogMap) {
      const persistedCatalogMap = catalogMap.filter((value, key) => {
        return CatalogKeys.CURRENT_SOURCE_ID === key;
      });

      newState = state.setIn([CatalogKeys.CATALOG], persistedCatalogMap);
    }

    return newState;
  },
  outbound(state) {
    // initial state when being rehydrated from redux-persist
    return state.mergeDeep(SERVER_SIDE_INITIAL_STATE);
  },
});

// initial state on first visit to site
export default (state = SERVER_SIDE_INITIAL_STATE, action) =>
  combineReducers({
    albums: albumsReducer,
    artists: artistsReducer,
    categories: categoriesReducer,
    catalog: catalogReducer,
    composers: composersReducer,
    curatorSources: curatorSourcesReducer,
    events: eventsReducer,
    genres: genresReducer,
    listeners: listenersReducer,
    lyrics: lyricsReducer,
    playlists: playlistReducer,
    playlistTracks: playlistTracksReducer,
    seeds: seedsReducer,
    stations: stationsReducer,
    tracks: tracksReducer,
    // Just used for browse
    catalogStations: catalogStationsReducer,
    browseSources: browseSourcesReducer,
  })(state, action);
